// extracted by mini-css-extract-plugin
export default {"reward":"Reward_reward__IE8PD","balanceIcon":"Reward_balanceIcon__BmWGA","ace":"Reward_ace__8Akht","plus":"Reward_plus__dD5Uw"};